import * as React from 'react';
import Input from 'antd/lib/input';
import Icon from 'antd/lib/icon';
import { ListAlert } from 'components';
import { Alert } from 'components/antd';
import { ThemeContext } from 'app-themes';

import classNames from 'classnames';

import styles from './InputPassword.module.scss';

import { PasswordState, PasswordProps } from 'antd/lib/input/Password';
import { isNil } from 'lodash-es';

export const PASSWORD_ERRORS = [
	'8 characters',
	'one non-alphanumeric character',
	'one lowercase letter',
	'one upercase letter',
];

const ActionMap: Record<string, string> = {
	click: 'onClick',
	hover: 'onMouseOver',
};

type InputPasswordAlignType = 'left' | 'right';

interface InputPasswordProps extends PasswordProps {
	showHint?: boolean;
	showPassPlaceholder?: boolean;
	align?: InputPasswordAlignType;
}
interface InputPasswordState extends PasswordState {
	isFocus?: boolean;
}
export default class InputPassword extends React.Component<InputPasswordProps, InputPasswordState> {
	static defaultProps = {
		inputPrefixCls: 'ant-input',
		prefixCls: 'ant-input-password',
		action: 'click',
		visibilityToggle: true,
		showPassPlaceholder: true,
		align: 'right',
	};
	static contextType = ThemeContext;

	private inputRef: any;

	saveInput = (inputRef: any) => {
		this.inputRef = inputRef;
	};

	state: InputPasswordState = {
		visible: false,
	};

	onChange = () => {
		this.setState({
			visible: !this.state.visible,
		});
	};

	focus() {
		this.inputRef.focus();
	}

	getIcon() {
		const { prefixCls, action } = this.props;
		const iconTrigger = ActionMap[action!] || '';
		const iconProps = {
			[iconTrigger]: this.onChange,
			className: `${prefixCls}-icon`,
			type: this.state.visible ? 'eye' : 'eyeInvisible',
			key: 'passwordIcon',
			onMouseDown: (e: MouseEvent) => {
				e.preventDefault();
			},
		};
		return <Icon {...iconProps} type={iconProps.type} />;
	}

	onFocus = (e: React.FocusEvent<HTMLInputElement>) => {
		this.setState({
			isFocus: true,
		});
		if (this.props.onFocus) {
			this.props.onFocus(e);
		}
	};

	onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
		this.setState({
			isFocus: false,
		});
		if (this.props.onBlur) {
			this.props.onBlur(e);
		}
	};

	get placeholder() {
		const { placeholder, showPassPlaceholder } = this.props;
		if (!isNil(placeholder)) {
			return placeholder;
		}
		return showPassPlaceholder ? '******' : '';
	}

	render() {
		const {
			className,
			prefixCls,
			inputPrefixCls,
			size,
			suffix,
			visibilityToggle,
			showHint,
			showPassPlaceholder,
			align,
			...restProps
		} = this.props;
		const { isFocus } = this.state;
		const suffixIcon = visibilityToggle && this.getIcon();
		const theme = this.context;
		const inputClassName = classNames(prefixCls, className, styles.inputPassword, {
			[`${prefixCls}-${size}`]: !!size,
			[styles[`inputPasswordAlertLeft`]]: align === 'left',
			[styles[`inputPassword-${theme}`]]: theme !== '',
		});
		const passwordHint = <ListAlert errors={PASSWORD_ERRORS} isPassword />;
		return (
			<>
				<Input
					{...restProps}
					type={this.state.visible ? 'text' : 'password'}
					ref={this.saveInput}
					size={size}
					className={inputClassName}
					prefixCls={inputPrefixCls}
					suffix={suffixIcon}
					onFocus={this.onFocus}
					onBlur={this.onBlur}
					placeholder={this.placeholder}
				/>
				{showHint && isFocus && <Alert type="info" message={passwordHint} showIcon />}
			</>
		);
	}
}
